import { defineStore } from 'pinia'

export const useAppSettingsStore = defineStore('appSettings', {
  state: () => ({
    isAuditStepperVisible: false,
    initialized: false,
  }),
  getters: {},
  actions: {
    async getAppSettings() {
      const { isAuthenticated } = useAuth()
      if (!isAuthenticated.value) {
        this.initialized = false
        return
      }
      if (this.initialized) return
      this.initialized = true
      try {
        const auditStore = useAuditStore()
        const positionStore = usePositionStore()
        const userStore = useUserStore()
        const orgStore = useOrgStore()
        const teamStore = useTeamStore()

        await Promise.all([userStore.getUser(), orgStore.getOrg()])
        if (!isAuthenticated.value) {
          this.initialized = false
          return
        }

        const results = await Promise.allSettled([
          auditStore.updateAuditList(),
          positionStore.updatePositionList(),
        ])
        // A rejected request may have cleared the session while these loads
        // were in flight. Never start a team request after that redirect.
        if (!isAuthenticated.value) {
          this.initialized = false
          return
        }
        const failure = results.find((result) => result.status === 'rejected')
        if (failure?.status === 'rejected') throw failure.reason

        if (orgStore.selected?.id) {
          await teamStore.getTeams(orgStore.selected.id)
        }
      } catch (error) {
        this.initialized = false
        throw error
      }
    },
    async save(_flush?: boolean): Promise<void> {
      // Implement save logic here
      // The `getAppSettings` is really just a nice place
      // to load all the app settings
      // when we have overall app settings
      // those will go here
    },
  },
})
